import { render, staticRenderFns } from "./SheraDigital.vue?vue&type=template&id=77982ed0&"
import script from "./SheraDigital.vue?vue&type=script&lang=js&"
export * from "./SheraDigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports